import CloudyIcon from '../Icons/WeatherIcons/CloudyIcon.mjs';
import DayFairThundershtormsIcon from '../Icons/WeatherIcons/DayFairThundershtormsIcon.mjs';
import DayIcon from '../Icons/WeatherIcons/DayIcon.mjs';
import DayMostlyCloudyIcon from '../Icons/WeatherIcons/DayMostlyCloudyIcon.mjs';
import DayMostlyCloudyShowersIcon from '../Icons/WeatherIcons/DayMostlyCloudyShowersIcon.mjs';
import DayMostlyFairIcon from '../Icons/WeatherIcons/DayMostlyFairIcon.mjs';
import DayPartlyCloudyIcon from '../Icons/WeatherIcons/DayPartlyCloudyIcon.mjs';
import DayPartlyShowersIcon from '../Icons/WeatherIcons/DayPartlyShowersIcon.mjs';
import DayPartlySnowShowersIcon from '../Icons/WeatherIcons/DayPartlySnowShowersIcon.mjs';
import FogIcon from '../Icons/WeatherIcons/FogIcon.mjs';
import FrigidIcon from '../Icons/WeatherIcons/FrigidIcon.mjs';
import HailIcon from '../Icons/WeatherIcons/HailIcon.mjs';
import HurricaneIcon from '../Icons/WeatherIcons/HurricaneIcon.mjs';
import MixedRainAndHailIcon from '../Icons/WeatherIcons/MixedRainAndHailIcon.mjs';
import NightFairThundershtormsIcon from '../Icons/WeatherIcons/NightFairThundershtormsIcon.mjs';
import NightIcon from '../Icons/WeatherIcons/NightIcon.mjs';
import NightMostlyCloudyIcon from '../Icons/WeatherIcons/NightMostlyCloudyIcon.mjs';
import 'react';
import 'styled-components';
import NightMostlyFairIcon from '../Icons/WeatherIcons/NightMostlyFairIcon.mjs';
import NightPartlyCloudyIcon from '../Icons/WeatherIcons/NightPartlyCloudyIcon.mjs';
import NightPartlyShowersIcon from '../Icons/WeatherIcons/NightPartlyShowersIcon.mjs';
import NightPartlySnowShowersIcon from '../Icons/WeatherIcons/NightPartlySnowShowersIcon.mjs';
import RainIcon from '../Icons/WeatherIcons/RainIcon.mjs';
import ShowersIcon from '../Icons/WeatherIcons/ShowersIcon.mjs';
import SnowIcon from '../Icons/WeatherIcons/SnowIcon.mjs';
import SnowShowersIcon from '../Icons/WeatherIcons/SnowShowersIcon.mjs';
import ThundershtormsIcon from '../Icons/WeatherIcons/ThundershtormsIcon.mjs';
import TornadoIcon from '../Icons/WeatherIcons/TornadoIcon.mjs';
import WindyIcon from '../Icons/WeatherIcons/WindyIcon.mjs';
import WintryMixIcon from '../Icons/WeatherIcons/WintryMixIcon.mjs';
import NotAvailable from '../Icons/WeatherIcons/NotAvailable.mjs';

const iconMap = {
    '0': { icon: TornadoIcon, alt: 'Tornado' },
    '1': { icon: ThundershtormsIcon, alt: 'Tropical Storm' },
    '2': { icon: HurricaneIcon, alt: 'Hurricane' },
    '3': { icon: ThundershtormsIcon, alt: 'Strong Storms' },
    '4': { icon: ThundershtormsIcon, alt: 'Thunderstorms' },
    '5': { icon: RainIcon, alt: 'Rain or Snow' },
    '6': { icon: RainIcon, alt: 'Rain or Sleet' },
    '7': { icon: WintryMixIcon, alt: 'Wintry Mix' },
    '8': { icon: WintryMixIcon, alt: 'Freezing Drizzle' },
    '9': { icon: ShowersIcon, alt: 'Drizzle' },
    '10': { icon: MixedRainAndHailIcon, alt: 'Freezing Rain' },
    '11': { icon: ShowersIcon, alt: 'Showers' },
    '12': { icon: RainIcon, alt: 'Rain' },
    '13': { icon: WindyIcon, alt: 'Flurries' },
    '14': { icon: SnowShowersIcon, alt: 'Snow Showers' },
    '15': { icon: SnowIcon, alt: 'Blowing or Drifting Snow' },
    '16': { icon: SnowIcon, alt: 'Snow' },
    '17': { icon: HailIcon, alt: 'Hail' },
    '18': { icon: MixedRainAndHailIcon, alt: 'Sleet' },
    '19': { icon: FogIcon, alt: 'Blowing Dust or Sandstorm' },
    '20': { icon: FogIcon, alt: 'Foggy' },
    '21': { icon: FogIcon, alt: 'Haze' },
    '22': { icon: FogIcon, alt: 'Smoke' },
    '23': { icon: WindyIcon, alt: 'Breezy' },
    '24': { icon: WindyIcon, alt: 'Windy' },
    '25': { icon: FrigidIcon, alt: 'Frigid or Ice Crystals' },
    '26': { icon: CloudyIcon, alt: 'Cloudy' },
    '27': { icon: NightMostlyCloudyIcon, alt: 'Mostly Cloudy Night' },
    '28': { icon: DayMostlyCloudyIcon, alt: 'Mostly Cloudy' },
    '29': { icon: NightPartlyCloudyIcon, alt: 'Partly Cloudy Night' },
    '30': { icon: DayPartlyCloudyIcon, alt: 'Partly Cloudy' },
    '31': { icon: NightIcon, alt: 'Clear' },
    '32': { icon: DayIcon, alt: 'Sunny' },
    '33': { icon: NightMostlyFairIcon, alt: 'Fair or Mostly Clear' },
    '34': { icon: DayMostlyFairIcon, alt: 'Fair or Mostly Sunny' },
    '35': { icon: MixedRainAndHailIcon, alt: 'Mixed Rain and Hail' },
    '36': { icon: DayIcon, alt: 'Sunny' },
    '37': { icon: DayFairThundershtormsIcon, alt: 'Isolated Thunderstorms' },
    '38': { icon: DayMostlyCloudyShowersIcon, alt: 'Scattered Thunderstorms' },
    '39': { icon: DayPartlyShowersIcon, alt: 'Scattered Showers' },
    '40': { icon: RainIcon, alt: 'Heavy Rain' },
    '41': { icon: DayPartlySnowShowersIcon, alt: 'Scattered Snow Shower' },
    '42': { icon: SnowIcon, alt: 'Heavy Snow' },
    '43': { icon: SnowIcon, alt: 'Blizzard' },
    '44': { icon: NotAvailable, alt: 'Not available' },
    '45': { icon: NightPartlyShowersIcon, alt: 'Scattered Showers Night' },
    '46': { icon: NightPartlySnowShowersIcon, alt: 'Scattered Snow Showers Night' },
    '47': { icon: NightFairThundershtormsIcon, alt: 'Scattered Thunderstorms Night' }
};
const NOT_AVAILABLE_ICON_CODE = '44';

export { NOT_AVAILABLE_ICON_CODE, iconMap as default };
//# sourceMappingURL=IconMap.mjs.map
